import main from './pen.svg';
import active from './pen-active.svg';
import disabled from './pen-disabled.svg';

export default { main, active, disabled };
